module.exports = __webpack_public_path__ + "static/media/document-icon.45288650.svg";